export default "__VITE_ASSET__RlELgq4E__"